/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from '@linc-technologies/linced-common/models/person';
import type School from '@linc-technologies/linced-common/models/school';
import type Structure from '@linc-technologies/linced-common/models/timetable/structure';
import moment from 'moment';

// Proto: timetable.Period.
export default class Period extends Model {
  declare [Type]: 'timetable/period';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @attr('string', { defaultValue: '' })
  declare shortName: string;

  @attr('string', { defaultValue: '' })
  declare longName: string;

  @attr('number', { defaultValue: 0 })
  declare duration: number;

  @attr('string')
  declare startTime: string | undefined;

  @belongsTo('timetable/structure', { async: true, inverse: null })
  declare structureId: AsyncBelongsTo<Structure>;

  @attr('number')
  declare createTime: number | undefined;

  @computed('startTime', 'duration')
  get endTime() {
    const startTime = this.startTime;
    const duration = this.duration;
    return moment(startTime, 'HH:mm').add(duration, 'm').format('HH:mm');
  }
}
